module.exports = __webpack_public_path__ + "img/toolbox.5ea97020.svg";